<template>
  <div class="HomePage">
    <!--  首页-->
    <div class="card">
      <div class="card-title">已购产品</div>
      <div class="card-cont" v-if="payList.length!==0">

        <div v-for="item in payList" :key="item.id" style="margin-right: 30px;height:110px">
          <a-progress
            type="dashboard"
            :width="80"
            :gapDegree="3"
            :status="
              ((item.totalNums - item.remainNums) / item.totalNums) * 100 >= 70
                ? 'exception'
                : ''
            "
            :percent="
              ((item.totalNums - item.remainNums) / item.totalNums) * 100
            "
          >
            <template #format="percent" v-if="!item.other">
              <span style="text-align: center; font-size: 12px">
                <div>共{{ item.totalNums }}{{ item.unit }}</div>
                <div style="margin-top: 5px" v-if="item.remainNums>0">剩余{{ item.remainNums }}{{ item.unit }}</div>
                <div style="margin-top: 5px;" v-else>已用完</div>
              </span>
            </template>
            <template #format="percent" v-else>
              <span style="text-align: center; font-size: 12px">
                <div>共{{ item.other.totalHour }}{{ item.unit }}</div>
                <div style="margin-top: 5px" v-if="item.remainNums>0">剩余{{ item.other.remainHour }}{{ item.unit }}</div>
                <div style="margin-top: 5px" v-if="item.remainNums>0">{{ item.other.remainMin }}分钟</div>
                <div style="margin-top: 5px;" v-else>已用完</div>
              </span>
            </template>
          </a-progress>
          <div class="card-cont-title">{{ item.serviceName }}</div>
        </div>
        
      </div>
       <div class="card-cont" v-if="payList.length==0" style="height:110px">
          <div style="height:110px;width:100%;text-align: center;padding:20px">暂无已购产品</div>
       </div>
    </div>
    <div class="card">
      <div class="card-title">产品中心</div>
      <div class="card-list" >
        <a-row>
          <a-col :span="5" v-for="item in cardDate">
            <div class="card-list-col">
              <div class="col-cont">
                <div class="imageWidth">
                  <!-- <img src="../../assets/homeIcon.png" class="col-img" /> -->
                  <img v-if="item.code === 'kongjian'" src="../../assets/存储服务器.png" class="col-img" alt="">
                  <img v-if="item.code === 'liuliang'" src="../../assets/流量.png" class="col-img" alt="">
                  <img v-if="item.code === 'zbdwsz'" src="../../assets/自定义主办单位.png" class="col-img" alt="">
                  <img v-if="item.code === 'jszcqgg'" src="../../assets/删除 (13).png" class="col-img" alt="">
                  <img v-if="item.name === '平台版本'" src="../../assets/版本号 (1).png" class="col-img" alt="">
                  <img v-if="item.code === 'luzhi'" src="../../assets/直播回放.png" class="col-img" alt="">
                  <img v-if="item.name === '会议微网站'" src="../../assets/微信端网页-圆.png" class="col-img" alt="">
                  <img v-if="item.name === '微网站代搭建'" src="../../assets/客服 (3).png" class="col-img" alt="">
                </div>
                <div style="margin: 0 0 0 10px">
                  <div class="col-title">{{ item.name }}</div>
                  <div class="shortIntro">{{ item.shortIntro }}</div>
                  <!-- <div v-html="item.serviceIntroduction" style="color: #8D8D8D" ></div> -->
                </div>
              </div>
              <div class="col-btn" @click="clickCard(item)">
                <span style="color: #00b75b" v-if="item.type === '1'"
                  >免费试用</span
                >
                <span style="color: #00b75b" v-else-if="item.type === '2'"
                  >免费咨询</span
                >
                <span style="color: #606060" v-else-if="item.type === '3'"
                  >了解看看</span
                >
                <span style="color: #606060" v-else>了解看看</span>
              </div>
            </div>
          </a-col>
        </a-row>
      </div>
    
    </div>
    <div class="card">
      <div class="card-title">合作推广</div>
      <div class="card-list">
        <a-row>
          <a-col :span="6" v-for="item in cardDateT">
            <div class="card-list-col">
              <div class="col-cont">
                <div>
                  <img :src="item.src" class="col-img" />
                </div>
                <div style="margin: 0 0 0 10px">
                  <div class="col-title">{{ item.title }}</div>
                  <div style="color: #8d8d8d">{{ item.abstract }}</div>
                </div>
              </div>
              <div >
                <a-tooltip>
                  <template slot="title">
                    <img
                      :src="KFImage"
                      style="width: 190px"
                    />
                  </template>
                  <span class="col-btn" style="color:#606060;width:100%;">了解看看</span>
                </a-tooltip>
              </div>
            </div>
          </a-col>
        </a-row>
      </div>
    </div>

    <!-- <ProductOrdering
      v-if="visibleProductOrdering"
      :visible="visibleProductOrdering"
      v-on:closeMain="closeProductOrdering"
  /> -->
    <!--购买后消费提示-->
    <DeductionPrompt
      v-if="visibleDeductionPrompt"
      :visible="visibleDeductionPrompt"
      v-on:closeDeductionPrompt="closeDeductionPrompt"
    />
    <!--  认证提示-->
    <MessageAlert
      :visible="visibleAlert"
      v-on:closeMain="closeMainAlert"
    ></MessageAlert>

    <!--      服务介绍
          免费搭建微网站服务code：mfdjwwz
          （收费）代理搭建微网站服务code：wwzdlfw   目前写死此code-->
    <LiveServiceIntro
      v-if="LiveIntroVisible"
      :visible="LiveIntroVisible"
      :serviceCode="serviceCode"
      v-on:closeMain="closeMainIntro"
      v-on:openExclusive="openExclusive"
    />
    <!--  专属客服-->
    <ServiceExclusive
      v-if="visibleExclusives"
      :visible="visibleExclusives"
      v-on:loseMainExclusives="closeMainExclusives"
    />
    <!-- 产品订购 -->
    <ProductOrderingNew
      v-if="visibleProductOrdering"
      :visible="visibleProductOrdering"
      :code="code"
      v-on:closeProductOrdering="closeProductOrdering"
    />
  </div>
</template>

<script>
import ProductOrderingNew from "@/components/PaidView/ProductOrderingNew";
import ProductOrdering from "@/components/PaidView/ProductOrdering";
import DeductionPrompt from "@/components/PaidView/DeductionPrompt";
import MessageAlert from "@/components/Authentication/MessageAlert";
import {
  getAuthenticationInformation,
  getserviceIntro,
  getPayedProduct,
  exclusiveKFImage
} from "@/service/authentication";
import LiveServiceIntro from "@/components/PaidView/LiveServiceIntro";
import ServiceExclusive from "@/components/PaidView/ServiceExclusive";
export default {
  name: "HomePage",
  components: {
    DeductionPrompt,
    ProductOrdering,
    MessageAlert,
    LiveServiceIntro,
    ServiceExclusive,
    ProductOrderingNew,
  },
  data() {
    return {
      cardDate: [
        {
          name: "会议微网站",
          type: "1",
          shortIntro: "3分钟制作专属会议网站",
        },
        {
          name: "微网站代搭建",
          type: "2",
          shortIntro: "专属客服搭建会议微网站",
        },
        {
          name: "平台版本",
          type: "3",
          shortIntro: "免费版/标准版/旗舰版",
        },
        // {
        //   title:'去除平台名称',
        //   abstract:'微网站首页去除平台名称logo',
        // },
        // {
        //   title:'设置会议主办方',
        //   abstract:'微网站首页显示主办方/承办方等名称logo',
        // },
        // {
        //   title:'短信',
        //   abstract:'短信验证码/发送短信',
        // },
        // {
        //   title:'邮件',
        //   abstract:'邮箱验证码/发送邮件',
        // },
        // {
        //   title:'存储空间',
        //   abstract:'存储图片/文件等',
        // },
        // {
        //   title:'案例展示',
        //   abstract:'微网站案例展示',
        // },
      ],
      cardDateT: [
        {
          title: "医驰平台推广",
          abstract: "推广介绍",
          src: require('../../assets/yich_logo.png')
        },
        {
          title: "云ICU平台推广",
          abstract: "推广介绍",
          src: require('../../assets/未标题-1.png')
        },
        {
          title: "IElearning平台推广",
          abstract: "推广介绍",
          src: require('../../assets/IE.png')
        },
        {
          title: "APnet平台推广",
          abstract: "推广介绍",
          src: require('../../assets/APnet.jpg')
        },
      ],
      visibleAlert: false,
      serviceCode: "wwzdlfw",
      visibleProductOrdering: false,
      visibleDeductionPrompt: false,
      visibleExclusives: false,
      LiveIntroVisible: false,
      userInfoList: [],
      isKefu: null,
      isKefuId: null,
      code: "",
      payList: [],
      KFImage:'',
    
    };
  },
  created() {
    const userInfo = JSON.parse(window.localStorage.getItem("yichi_userInfo"));
    this.isKefu = userInfo.isKefu;
    this.isKefuId = userInfo.id;
    this.getInformation();
    this.getServiceList();
    this.getPayNumber();
    if(this.$route.query.serviceCode){
       this.ProductOrder(this.$route.query.serviceCode);
    }
     this.getKFImage();
   
  },
  methods: {
    closeMainExclusives(val) {
      //关闭专属客服
      this.visibleExclusives = val;
    },
    openExclusive() {
     
      
      //关闭免费领取一次搭建的弹窗
      
       
          this.visibleExclusives = true;
        



      
    },
    closeMainIntro(val) {
      this.LiveIntroVisible = val;
    },
    closeProductOrdering(val) {
      this.visibleProductOrdering = val;
      this.code = "";
    },
    closeDeductionPrompt(val) {
      this.visibleDeductionPrompt = val;
    },
    closeMainAlert(val) {
      this.visibleAlert = val;
    },
    clickCard(item) {
     
      
      if (item.type !==undefined) {
        switch (item.type) {
          case "1": //去搭建会议页面
            sessionStorage.removeItem("pageParams");
            if (!this.userInfoList.id && !this.isKefu) {
              //未认证且不是客服
              this.visibleAlert = true;
            } else {
              //客服
              this.$store.dispatch("isShowNav", false); //导航栏
              if (this.$route.query.memberId) {
                this.$router.push({
                  path: "meeting",
                  query: { memberId: this.isKefuId },
                });
              } else {
                this.$router.push({ path: "meeting" });
              }
            }
            break;
          case "2": //咨询
            this.serviceCode = "wwzdlfw"; //服务咨询
            this.LiveIntroVisible = true;
            console.log(this.LiveIntroVisible);
            
            break;
          case "3":
              this.$router.push('/orderServices')
        }
      } else {
        if(!this.userInfoList.id && !this.isKefu){
            //未认证且不是客服
            this.visibleAlert = true;
         }
         else{
          this.ProductOrder(item.code);
         }
        
      }
    },
    async getInformation() {
      const response = await getAuthenticationInformation();
      if (response.code === 200) {
        this.userInfoList = response.data;
      } else {
        this.$message.warning("name", response.message);
      }
    },
    async getServiceList() {
      const res = await getserviceIntro();
      if (res.code == 0) {
        this.cardDate = [...this.cardDate, ...res.data];
        console.log("11数据",this.cardDate);
      }
    },
    // 产品订购
    ProductOrder(code) {
      this.code = code;
      this.visibleProductOrdering = true;
      console.log(this.visibleProductOrdering);
    },
    async getPayNumber() {
      const res = await getPayedProduct();
      if (res.code == 0) {
        this.payList = res.data;
      } else {
        this.$message.warning(res.message);
      }
    },
     //获取客服二维码
    async getKFImage() {
      const response = await exclusiveKFImage();
      if (response.code === 200) {
        this.KFImage = response.data;
        this.$store.dispatch("kefuImg", response.data); //客服二维码
      } else {
        this.$message.warning(response.message);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.ant-col-5 {
  width: 20%;
}
.ant-col-4 {
  width: 16.66666666%;
}
.HomePage {
  border: 10px solid #edeff2;
  background-color: red;
  .card {
    border-bottom: 10px solid #edeff2;
    background-color: #ffffff;
  }
  .card-title {
    padding: 15px;
    font-weight: bold;
    color: #333333;
    border-bottom: 1px solid #edeff2;
  }
  .card-cont {
    display: flex;
    padding: 20px;
    text-align: center;
    .card-cont-title {
      font-weight: bold;
      margin-top: 10px;
    }
  }
  .card-list {
    padding: 0 10px 20px 10px;
    .card-list-col {
      border: 1px solid #f5f5f5;
      height: 150px;
      margin: 20px 10px 0 10px;
      box-shadow: 3px 1px 5px rgba(0, 0, 0, 0.2);
      border-radius: 3px;
      position: relative;
      .col-cont {
        display: flex;
        padding: 20px 10px 10px 10px;
        .col-img {
          width: 50px;
          height: 50px;
        }
        .col-title {
          font-size: 16px;
          font-weight: bold;
          color: #272727;
          margin-bottom: 10px;
        }
      }
      .col-btn {
        height: 40px;
        line-height: 40px;
        text-align: center;
        border-top: 1px solid #edeff2;
        position: absolute;
        bottom: 0;
        width: 100%;
        cursor: pointer;
       
      }
    }
  }
}

.shortIntro{
  display: -webkit-box;          /* 弹性伸缩盒子模型 */
  -webkit-box-orient: vertical;  /* 垂直排列 */
  -webkit-line-clamp: 2;         /* 限制显示两行 */
  overflow: hidden;              /* 超出部分隐藏 */
  text-overflow: ellipsis;       /* 超出部分显示省略号 */
}
::v-deep .ant-tooltip-inner {
  background-color: white;
  color: #333; /* 文字颜色改为深色 */
}
::v-deep .ant-tooltip-arrow::before {
  background-color: white;
}
</style>
